module.exports = __webpack_public_path__ + "static/build-3258b38ed9eb4d92a40eb5f2704d0971.jpg";